<template></template>

<script>
import { $get, $post } from "@/utils/request";
export default {
  created() {
    this.thirdToken = this.$route.query.key;
    this.thirdLogin();
  },
  methods: {
    async thirdLogin() {
      if (this.verConfig.supportThirdLogin) {
        try {
          const res = await $post("/users/third/login", {
            key: this.thirdToken,
          });
          const { ret, msg, data } = res.data;
          if(ret == 1){
            this.$cookie.set("userInfo", JSON.stringify(data));
            this.$cookie.set("token", data.token);
            this.$router.replace({ name: "goods" });
          }
        } catch (error) {}
      }
    },
  },
};
</script>